const ContactSubject = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-subject" */ '@/pages/base-info/crm/contact-subject/index.vue'
  )
const CreateContactSubject = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-subject" */ '@/pages/base-info/crm/contact-subject/create.vue'
  )
const EditContactSubject = () =>
  import(
    /* webpackChunkName: "base-info-crm-contact-subject" */ '@/pages/base-info/crm/contact-subject/edit.vue'
  )

export default {
  path: 'contact-subject',
  meta: {
    label: 'ContactSubject',
    auth: 'subject'
  },
  component: {
    name: 'Subject',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCrmContactSubject',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: ContactSubject
    },
    {
      name: 'BaseInfoCreateCrmContactSubject',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContactSubject
    },
    {
      name: 'BaseInfoEditCrmContactSubject',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditContactSubject,
      props: true
    }
  ]
}
